import styled from "@emotion/styled";
import { css } from "@emotion/core";
import { NectarTheme } from "@nectarTypes";
import { Heading, Text } from "nectar-ui";

export const HeadingContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${theme.spacings.lg};
    display: flex;
  `}
`;

export const TitleContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacings.xs};
  `}
`;

export const CustomHeading = styled(Heading)`
  line-height: 1.15;
  letter-spacing: 0;
`;

export const Subtitle = styled(Text)<NectarTheme>`
  ${({ theme }) => css`
    display: none;

    ${theme.breakpoints.sm} {
      display: flex;
    }
  `}
`;
